import { render, staticRenderFns } from "./new-messages-notification.vue?vue&type=template&id=6a387406&scoped=true&"
import script from "./new-messages-notification.vue?vue&type=script&lang=js&"
export * from "./new-messages-notification.vue?vue&type=script&lang=js&"
import style0 from "./new-messages-notification.vue?vue&type=style&index=0&id=6a387406&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a387406",
  null
  
)

export default component.exports